import script from "./helpTooltip.vue?vue&type=script&lang=ts&setup=true"
export * from "./helpTooltip.vue?vue&type=script&lang=ts&setup=true"

import "./helpTooltip.vue?vue&type=style&index=0&id=332330d0&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-332330d0"]])

export default __exports__